module.exports = __webpack_public_path__ + "images/檀程长图_06-4.jpg?v=a8246414";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_06-4.jpg
 ** module id = 194
 ** module chunks = 1 2
 **/